import gql from 'graphql-tag';
import User from '../../entity/User';
import GraphQLClient from '../../adapter/GraphQLClient';

class AuthUserWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ idGraphqlClient }: { idGraphqlClient: GraphQLClient }) {
    this.graphqlClient = idGraphqlClient;
  }

  public getMe = async (): Promise<User> => {
    const result = await this.graphqlClient.query(
      gql`
        query currentUser {
          currentUser {
            id
            name
            profileImageUrl
            email
          }
        }
      `,
    );
    return User.fromJSON(result.currentUser) as User;
  };
}

export class MeNotFound extends Error {
  public readonly name = 'MeNotFound';
  public readonly message = 'The "me" current user is not found.';

  constructor() {
    super();
  }
}

export default AuthUserWebApi;
